export interface ChartOfAccount {
	id: string;
	code: string;
	name: string;
	account_type: string;
	normal_balance: "debit" | "credit" | string;
	parent_code: string | null;
	is_active: boolean;
}

export type JournalAccountPurpose =
	| "accounts_receivable_trade"
	| "sales_revenue"
	| "sales_revenue_exempt"
	| "sales_revenue_zero_rated"
	| "output_vat"
	| "cash_in_bank"
	| "creditable_withholding_tax"
	| "liquidated_damages"
	| "retention_receivable"
	| "municipal_charge"
	| "bank_charge";

export interface JournalAccountSetting {
	purpose: JournalAccountPurpose;
	account_code: string;
	account_name: string | null;
}

export const JOURNAL_ACCOUNT_PURPOSE_LABELS: Record<JournalAccountPurpose, string> = {
	accounts_receivable_trade: "Accounts Receivable (DR)",
	sales_revenue: "Sales Revenue — Vatable (CR)",
	sales_revenue_exempt: "Sales Revenue — VAT Exempt (CR)",
	sales_revenue_zero_rated: "Sales Revenue — Zero Rated (CR)",
	output_vat: "Output VAT (CR)",
	cash_in_bank: "Cash in Bank (DR — collection)",
	creditable_withholding_tax: "Creditable Withholding Tax (DR — collection)",
	liquidated_damages: "Liquidated Damages (DR — collection)",
	retention_receivable: "Retention Receivable (DR — collection)",
	municipal_charge: "Municipal Charge (DR — collection)",
	bank_charge: "Bank Charges (DR — collection)",
};
